import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import Switch from 'react-switch'
import { sizeOptions } from './constants'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'

const InfantMeatsPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Size: item.Size,
    Organic: item.Organic,
  })
  const methods = useFormContext()
  const { setSelectReviewer, setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { Size, Organic } = item
      setPackaging({
        Size,
        Organic,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={4}>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={sizeOptions}
            defaultValue={{
              label: packaging.Size,
              value: packaging.Size,
            }}
            name="Size"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Size'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              message={'⚠ This selection is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
        </Col>
        <Col xs={4}></Col>
        <Col xs={4}>
          <FormGroup>
            <p>
              <strong>Organic</strong>
            </p>
            <Controller
              as={Switch}
              name="Organic"
              id="Organic"
              defaultValue={packaging.Organic}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              disabled={isDisabled}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

InfantMeatsPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default InfantMeatsPackageReview
